import ContainerFluid from './ContainerFluid'

export default ContainerFluid
